import {
  SPACE_SELECTOR_ITEM_TYPE,
  SPACE_SELECTOR_ARCHIVED_TOGGLE,
} from '../../constants/analytics';
import { analyticsTrackEvent } from '../../utils/analytics';
import { openTimestamp, openCorrelationId } from '../selectors';
import getNow from '../getNow';

const toggleArchivedSpaceSelector =
  (showArchived, sort, category) => (_dispatch, getState) => {
    const state = getState();

    analyticsTrackEvent(SPACE_SELECTOR_ARCHIVED_TOGGLE, {
      itemType: SPACE_SELECTOR_ITEM_TYPE,
      selectorOpenFor: Math.round(getNow() - openTimestamp(state)),
      correlationId: openCorrelationId(state),
      showArchived,
      sort,
      categoriesEnabled: true,
      category,
    });
  };

export default toggleArchivedSpaceSelector;
